/**
 * @generated SignedSource<<1216af26388ab46649b102cb676ad2f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MultiUploadInputObject = {
  uploads: ReadonlyArray<UploadInputObject>;
};
export type UploadInputObject = {
  id: string;
  metadata: UploadMetadataInputObject;
  storage: string;
};
export type UploadMetadataInputObject = {
  filename: string;
  mimeType: string;
  size: number;
};
export type rulesPage_AttributionMemoryImportStartMutation$variables = {
  multiUploadInput: MultiUploadInputObject;
};
export type rulesPage_AttributionMemoryImportStartMutation$data = {
  readonly attributionMemoryImportStart: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly multiUpload: {
      readonly id: string;
      readonly phase: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type rulesPage_AttributionMemoryImportStartMutation = {
  response: rulesPage_AttributionMemoryImportStartMutation$data;
  variables: rulesPage_AttributionMemoryImportStartMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "multiUploadInput"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "multiUploadInput",
    "variableName": "multiUploadInput"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "MultiUpload",
  "kind": "LinkedField",
  "name": "multiUpload",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phase",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "rulesPage_AttributionMemoryImportStartMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AttributionMemoryImportStartMutationPayload",
        "kind": "LinkedField",
        "name": "attributionMemoryImportStart",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "rulesPage_AttributionMemoryImportStartMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AttributionMemoryImportStartMutationPayload",
        "kind": "LinkedField",
        "name": "attributionMemoryImportStart",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e3461862744ff54ae10aae75664a415f",
    "id": null,
    "metadata": {},
    "name": "rulesPage_AttributionMemoryImportStartMutation",
    "operationKind": "mutation",
    "text": "mutation rulesPage_AttributionMemoryImportStartMutation(\n  $multiUploadInput: MultiUploadInputObject!\n) {\n  attributionMemoryImportStart(multiUploadInput: $multiUploadInput) {\n    multiUpload {\n      id\n      phase\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "41779c18c879fd663b6f09961f31d70e";

export default node;
